import React, { useLayoutEffect, useRef } from 'react';
import InvoiceAutomationPlaceholderEnum from '../../../Enums/InvoiceAutomationPlaceholderEnum';
import { fillTemplate, getMonthIso } from '../../../Helpers/invoiceAutomationSetupPageHelper';
import { insertPlaceholder } from '../../../Helpers/invoiceAutomationEditorHelper';

// The Internal Reference Number of an automatic invoicing setup (InputTypesEnum.InvoiceReferenceTemplate): a text in
// which {Month} and {Year} become a draft's month and year. + Month and + Year put one in where the cursor is and put
// the cursor back after it, and the name this month's draft gets shows under it. onChange gets the field's name and the
// new text, as a text field's does.
export default function InvoiceReferenceTemplateField({
  fieldName = '',
  value = '',
  placeholder = '',
  maxLength = null,
  className = 'w-100 form-control form-control-sm',
  onChange = (changedFieldName, newValue) => {},
}) {
  const input = useRef(null);
  // Where the cursor goes once the text with the new placeholder is shown: { text, position }.
  const caretAfterPlaceholder = useRef(null);
  const text = value ?? '';
  const thisMonthsName = fillTemplate(text.trim(), getMonthIso(new Date()));

  // The cursor goes back into the field, just after the placeholder put in, so that typing carries on there: left on
  // the button, the next letters went nowhere and a space put the placeholder in again. It waits for the new text,
  // because setting a field's value moves the cursor to its end.
  useLayoutEffect(() => {
    const caret = caretAfterPlaceholder.current;
    caretAfterPlaceholder.current = null;
    if (caret === null || caret.text !== text || !input.current) {
      return;
    }

    input.current.focus();
    input.current.setSelectionRange(caret.position, caret.position);
  }, [text]);

  function addPlaceholder(placeholderToAdd) {
    const position = input.current?.selectionStart ?? text.length;
    const newText = insertPlaceholder(text, placeholderToAdd, position);
    caretAfterPlaceholder.current = {
      text: newText,
      position: newText.indexOf(placeholderToAdd, position) + placeholderToAdd.length,
    };
    onChange(fieldName, newText);
  }

  return (
    <div className='w-100 iauto-reference'>
      <div className='iauto-reference-row'>
        <input
          ref={input}
          id={`htmlidfor${fieldName}`}
          type='text'
          className={className}
          value={text}
          placeholder={placeholder}
          maxLength={maxLength ?? undefined}
          autoComplete='off'
          onChange={(e) => onChange(fieldName, e.target.value)}
        />
        <button
          type='button'
          className='btn sm'
          onClick={() => addPlaceholder(InvoiceAutomationPlaceholderEnum.Month)}
        >
          + Month
        </button>
        <button
          type='button'
          className='btn sm'
          onClick={() => addPlaceholder(InvoiceAutomationPlaceholderEnum.Year)}
        >
          + Year
        </button>
      </div>
      {thisMonthsName && (
        <div className='iauto-reference-preview'>
          This month&apos;s draft: <b>{thisMonthsName}</b>
        </div>
      )}
      <div className='iauto-reference-note'>{"{Month} and {Year} become the draft's month and year."}</div>
    </div>
  );
}
